import { configureStore } from '@reduxjs/toolkit';
import cartReducer from '../ReduxCart/Cart/cartSlice';

export const store = configureStore({
  reducer: {
    cart: cartReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  }),
});